// the css is injected automatically
require('!style-loader!css-loader!postcss-loader!stylus-loader!./dropdown.styl');

var getData = require('../../scripts/getdata')(MBGF.mbfa_apibase);
var validation = require('validation')(getData).dropdown;

// this helps us remove everything exepct whats inside the body node
var strip = require("striphtml");

// accented characters to accept since javascript \w doesnt accept these by default
var accentedCharacters = "àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ";
var specialCharacters = "\.\!#\$\^%()+\;,\/\|\?";

function parse(text, next) {
    strip(require('raw!./dropdown.html'), function(theOutputHtml) {
        var parseRe = new RegExp("\\[(\\w[\\w" + accentedCharacters + specialCharacters + " \\t_\\-]*)(?:\\:{1}([A-Za-z0-9]+)?)?(\\*?)\\s*=[ \\t]*\\{(([a-zA-Z" + accentedCharacters + specialCharacters + "0-9 \\t\\-(?:>|&gt;)]+)|([\\[\\]a-zA-Z" + accentedCharacters + specialCharacters + "0-9 \\t\\-(?:>|&gt;)]+))\\}\\]", "g");
        var match = parseRe.exec(text);

        while (match != null) {

            var container = document.createElement("div");
            container.innerHTML = theOutputHtml;
            var domObj = container.firstChild;
            var keyExtra = (typeof match[2] != 'undefined') ? match[2] : '';

            var cleanedName = match[1].trim().replace(/\t/g, ' ');
            var id = cleanedName.replace(/[ \t]/g, '_').toLowerCase();
            
            var output = '<label for="' + id + '">' + cleanedName + '</label>\n' +
    					 '<select id="' + id + '" name="' + id + '" data-keyextra="' + keyExtra + '">';

            if (!match[6]) {
                match[4].split(',').forEach(function (opt) {
                    output += handleSingleOpt(opt);
                });
            }
            else {
                //console.log('we have optgroups');
                //console.log(match);
                var passedGroup = false;
                match[6].split(',').forEach(function (opt) {
                    if (opt.indexOf("[") > -1 ) {
                        passedGroup = true;
                    }

                    if (!passedGroup) {
                        output += handleSingleOpt(opt);
                    }
                });

                match[6].split('],').forEach(function (grp) {
                    if (grp.indexOf(',') > -1 && grp.indexOf(',') < grp.indexOf('[')) {
                        grp = grp.substring(grp.indexOf(',') + 1);
                    }

                    var grpNameRegex = /^([A-Za-z \-0-9])+(?=\[)/g;
                    var grpNameMatch = grpNameRegex.exec(grp.trim());
                    // if group-name start opgroup
                    if (grpNameMatch) {
                        output += '<optgroup label="' + grpNameMatch[0].trim() + '">';
                        var grpOptRegex = new RegExp("([\[])+([a-zA-Z" + accentedCharacters + specialCharacters + "0-9 \\t\\-(?:>|&gt;)]+)+", "g");
                        var grpOptMatch = grpOptRegex.exec(grp.trim())

                        grpOptMatch[2].split(',').forEach(function (opt) {
                            output += handleSingleOpt(opt);
                        });

                    }
                    else {
                        output += handleSingleOpt(grp);
                    }

                    // if group-name end the optgroup
                    if (grpNameMatch) {
                        output += '</optgroup>';
                    }
                });
            }

            output += '</select>\n';
            if(id === 'select'){ // Handle custom select fields
                domObj.classList.remove("mbgf-column-row");
                output += '<div class="message"></div>';
            }
            domObj.innerHTML = output;
            outputHtml = container.innerHTML;

            if (match[3] == "*") {
                var container = document.createElement("div");
                container.innerHTML = outputHtml;
                var domObj = container.firstChild;

                var selects = domObj.getElementsByTagName("select");

                for (var i = 0; i < selects.length; i++)
                {
                    selects[i].setAttribute("required", "true");
                    if (selects[i].children && selects[i].children.length > 0) {
                        var firstOption = selects[i].children[0];
                        if (firstOption.value === 'null' ){
                            firstOption.innerHTML += '*';
                        }
                        
                    }
                }

                // add a "required" class to the parent node
                domObj.setAttribute("class", domObj.getAttribute("class") + " required");
                domObj.setAttribute("data-required", "true");

                outputHtml = container.innerHTML;
            }

            text = text.replace(match[0], outputHtml);

            match = parseRe.exec(text);
        }

        next(text);
    });

};

function handleSingleOpt(opt) {
    var selectedItemRegex = /\((.*)\)/g;
    // Test to see if option is surrounded by parens, indicating it's the default option
    var match = selectedItemRegex.exec(opt);
    var contents = match ? match[1].trim() : opt.trim();
    // Test to see if using the "value -> name" type of option
    var namedOptionRegex = /(.+)\-(?:>|&gt;)(.+)/g;
    var namedOptionMatch = namedOptionRegex.exec(contents);
    var optionName, optionValue;
    if (namedOptionMatch) {
        optionValue = namedOptionMatch[1].trim();
        optionName = namedOptionMatch[2].trim();
    } else {
        optionName = contents;
        optionValue = contents;
    }
    return '<option value="' + optionValue + '"' +
              (match ? ' selected="selected">' : '>')
              + optionName + '</option>';
}

function validate(context) {
    var selects = context.getElementsByTagName("select");
    var select = selects[0];

    var required = context.getAttribute("data-required") == "true";

    var value = select ? select.options[select.selectedIndex].value : "";

    if (select && select.selectedIndex == 0) {
        value = (value != "null") ? value : "";
    }

    var validationResult = validation.validate(value, required);

    var currentClasses = context.getAttribute("class") || "";

    if (!validationResult.valid) {
        if (currentClasses.indexOf("error") == -1) {
            context.setAttribute("class", currentClasses + " error");
        }
    }
    else {
        currentClasses = currentClasses.replace(/(|\s)error(|\s)/g, "");
        context.setAttribute("class", currentClasses);
    }

    return validationResult.valid;
}

function getDataKey(context) {
    var domInput = context.getElementsByTagName("select")[0];
    var key = domInput.getAttribute("name");
    var keyExtra = domInput.getAttribute("data-keyextra");
    if (keyExtra.length) {
        key += "." + keyExtra;
    }
    return key;
}

function get(context) {
    var selects = context.getElementsByTagName("select");
    var select = selects[0];
    var value = select.options[select.selectedIndex].value;

    value = (value != "null") ? value : "";
    return value;
}

function reset(context) {
    var selects = context.getElementsByTagName("select");
    for(var i = 0; i < selects.length; i++) {
      selects[i].selectedIndex =0;
    } 
}

module.exports = {
    parse: parse,
    validate: validate,
    getDataKey: getDataKey,
    get: get,
    reset: reset
};



// WEBPACK FOOTER //
// ./js-src/markdown-editor/modules/dropdown/dropdown.js